'use strict';

const _=require('pulsar-utils/dist-es6/_');
const ValidatedFieldDirective=require('../../../../dist-es6/client/directives/validatedFieldDirective/validatedFieldDirective');

const LocalReferenceMidnight=new Date(1970,0,1);
const DefaultTimePickerOptions={
step:15,
timeFormat:'h:i A',
minDate:LocalReferenceMidnight};let


ValidatedTimePickerDirective=class ValidatedTimePickerDirective extends ValidatedFieldDirective{
get objectBindings(){
return['form','value','submissionResult','customErrorHandler','isDisabled','disabledClassOnly','timePickerOptions'];
}

get templateUrl(){
return'/templates/directives/validatedTimePickerDirective/validatedTimePickerTemplate';
}

get controller(){
return ValidatedTimePickerController;
}};let


ValidatedTimePickerController=class ValidatedTimePickerController extends ValidatedFieldDirective.controller{
static get $inject(){
return['$scope','$timeout','$element'];
}

constructor($scope,$timeout,$element){
super($scope);



if(_.exists(this.value)&&this.value instanceof Date){
this.valueAsDate=new Date(this.value);
}else{
this.valueAsDate=new Date(LocalReferenceMidnight);
}

this._defaultTime=new Date(this.valueAsDate);
this._defaultErrorMessage='Invalid time.';
this.timePickerOptions=_.assign({},_.cloneDeep(DefaultTimePickerOptions),_.cloneDeep(this.timePickerOptions));

let resetOnNextUpdate=!1;
$scope.$watch('controller.valueAsDate',newValue=>{
if(!_.exists(newValue)){
resetOnNextUpdate=!0;
}else if(resetOnNextUpdate){
resetOnNextUpdate=!1;
this.valueAsDate=this._getCorrectedTimeSinceMidnightAsDate(this.form[this.fieldId].$viewValue);
}else{
this.value=this.valueAsDate.getTime()-this._defaultTime.getTime();
}
});

$element.find('input').bind('blur',()=>{

if(_.exists(this.valueAsDate)&&_.isDate(this.valueAsDate)&&_.isNaN(this.valueAsDate.getTime())){
$timeout(()=>{
this.valueAsDate=this._getCorrectedTimeSinceMidnightAsDate($element.find('input')[0].value);
this.value=this.valueAsDate.getTime()-this._defaultTime.getTime();
});
}
});
}

_getCorrectedTimeSinceMidnightAsDate(viewValue){
let[viewHours,viewMinutes,viewMeridian]=viewValue.split(/[^APM0-9]/gi);

let hours=parseInt(viewHours,10);
if(viewMeridian==='AM'){
if(hours===12){
hours=0;
}
}else if(hours!==12){
hours+=12;
}

let minutes=parseInt(viewMinutes,10);

return new Date(new Date(this._defaultTime).setHours(hours,minutes,0,0));
}};


module.exports=ValidatedTimePickerDirective;
//# sourceMappingURL=validatedTimePickerDirective.js.map
